import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { TranslationService } from "@services/translation.service";
import { AlertCategory } from "src/app/main/modules/alerts/_enums/alerts.enums";
import { IAlertRuleRecord } from "src/app/main/modules/alerts/_models/alerts.interfaces";
import { AlertReviewService } from "src/app/main/modules/alerts/_services/alert-review.service";
import { AlertsService } from "src/app/main/modules/alerts/_services/alerts.service";
import "./alert-detail.component.scss";

@Component({
    selector: "alert-detail",
    template: require("./alert-detail.component.html")
})
export class AlertDetailComponent implements OnInit, OnChanges {

    @Input() record: IAlertRuleRecord;
    @Input() tableMode?: boolean = false;
    @Input() category?: AlertCategory;
    @Input() subcategory?: number;
    categoryString = "";

    updating = false;

    constructor(
        private readonly alertReviewService: AlertReviewService,
        private readonly alertsService: AlertsService,
        private readonly translationService: TranslationService
    ) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.record) {
            return;
        }

        this.getCategory();

    }

    private getCategory() {
        if (this.category === undefined || this.category === null) {
            return;
        }

        this.categoryString = this.translationService.tEnum(AlertCategory, 'AlertCategory', this.category);
        if (this.subcategory !== undefined || this.subcategory !== null) {
            const { subCategoryEnum, subCategoryString } = this.alertsService.getAlertRuleSubcategoryEnum(this.category);
            const subCatString = this.translationService.tEnum(subCategoryEnum, subCategoryString, this.subcategory);
            this.categoryString += ` > ${subCatString}`;
        }
    }
}
